module.exports = __webpack_public_path__ + "media/icons/plus-f9afd3fedc7dc3f6a941fd433bd4ba9c.svg";